import $ from 'jquery';

export default {
    init() {
      // JavaScript to be fired on the archive pages
  
    },
    finalize() {
        if ($('body').hasClass('post-type-archive-dementia_essentials')){
            $(".de_more_details").on('click', function(){
                var num = $(this).attr('num');
                $(this).hide();
                $(".read_more_decontent_"+num).removeClass('d-none');
                $(".de_div_less_"+num).removeClass('d-none');
                $(".read_more_decontent_"+num).fadeIn();
                $(".de_div_less_"+num).show();
            });

            $(".de_less_details").on ('click', function(){
                var num = $(this).attr('num');
                $(this).hide();
                $(".read_more_decontent_"+num).addClass('d-none');
                $(".de_div_less_"+num).addClass('d-none');
                $(".read_more_decontent_"+num).fadeOut();
                $(".de_div_more_"+num).show();
            });
        }
    }
  };


// WEBPACK FOOTER //
// ./scripts/routes/archive.js